import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const helpers = window.BASE_HELPERS || {};
const { YouTubePlayer } = helpers;

const MODULE = document.querySelectorAll('[data-module="banner_principal"]');

class BannerPrincipal {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    async init() {
        for (const component of this.components) {
            const swiperComponent = component.querySelector('.swiper');
            if (swiperComponent) {
                this.initSwiper(swiperComponent);
            }

            const videoElement = component.querySelector('[data-youtube-id]');
            if (!videoElement) continue;

            const videoId = videoElement.dataset.youtubeId;
            const elementId = videoElement.id || `yt-${videoId}`;
            const box = videoElement;

            await YouTubePlayer.mount({
                videoId,
                elementId,
                onStateChange: (event) => {
                    switch (event.data) {
                        case YT.PlayerState.PLAYING:
                            box.classList.add('active');
                            YouTubePlayer.pauseOthers(elementId);
                            break;
                        case YT.PlayerState.PAUSED:
                        case YT.PlayerState.ENDED:
                            box.classList.remove('active');
                            break;
                    }
                },
            });
        }
    }

    initSwiper(swiperComponent) {
        const swiper = new Swiper(swiperComponent, {
            modules: [Pagination, Navigation, Autoplay],
            loop: false,
            slidesPerView: 1,
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperComponent.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
            on: {
                afterInit: (swiper) => {
                    const currentSlide = swiper.slides[swiper.activeIndex];

                    if (currentSlide.dataset.type === 'youtube') {
                        const videoElement = currentSlide.querySelector('[data-youtube-id]');
                        if (!videoElement) return;

                        const elementId = videoElement.id || `yt-${videoElement.dataset.youtubeId}`;

                        if (YouTubePlayer.play) {
                            YouTubePlayer.play(elementId);
                        }
                    } else if (currentSlide.dataset.type === 'video') {
                        const videoElement = currentSlide.querySelector('video');
                        if (!videoElement) return;

                        videoElement.play();
                    }
                },
                slideChange: () => {
                    if (YouTubePlayer.pauseAll) {
                        YouTubePlayer.pauseAll();
                    } else if (YouTubePlayer.pauseOthers) {
                        YouTubePlayer.pauseOthers();
                    }

                    swiper.slidesEl.querySelectorAll('video').forEach(video => {
                        video.pause();
                    });

                    const currentSlide = swiper.slides[swiper.activeIndex];
                    if (!currentSlide) return;

                    if (currentSlide.dataset.type === 'youtube') {
                        const videoElement = currentSlide.querySelector('[data-youtube-id]');
                        if (!videoElement) return;

                        const elementId = videoElement.id || `yt-${videoElement.dataset.youtubeId}`;

                        if (YouTubePlayer.play) {
                            YouTubePlayer.play(elementId);
                        }
                    } else if (currentSlide.dataset.type === 'video') {
                        const videoElement = currentSlide.querySelector('video');
                        if (!videoElement) return;

                        videoElement.play();
                    }
                }
            }
        });
    }
}

(() => {
    if (MODULE) {
        new BannerPrincipal();
    }
})();

export default BannerPrincipal;
